/*globals $*/
'use strict';
/* ==========================================================================
   GLOBAL VARS
   ========================================================================== */
var regexMobile = '/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/';
var isMobile = navigator.userAgent.match(regexMobile);
var slider_home;

$(document).ready(function() {

  $('#close-popup-anuncio').on('click', function() {
       $('#popup-anuncio').removeClass('visible');
    });

  if ($('.owl-carousel').length) {
    $(".owl-carousel").owlCarousel({
      items:1,
      loop:false,
      nav: false,
      dots: true,
      smartSpeed:450
    });
  }

  $('#removecookie').on('click', function() {
      $('#cookie-allow').css('display', 'none');
  });
  altura_fondo();

  $('#nav-open-close').click(function() {

      if( $('#nav-open-close').hasClass('open') ){
        cerrar();
      } else {
        $('#nav-open-close').addClass('open');
        var val = 'translateX(-200px)';
        mover(document.getElementById('menu-desplegable'), val);
        $('#negroID').fadeIn();
      }
  });

  $('.menu-mobile li a').click(function() {
      if( $('#nav-open-close').hasClass('open') ){
        cerrar();
      }
  });


  $('#negroID').click(function() {
      cerrar();
  });

  $('.contact-item').click(function(){
    $('html,body').animate({scrollTop: $('.map-section').offset().top}, 1700);
  });

  //script para la pagina PARA LLEVAR
  $(".button").on("click", function() {
    var $button = $(this);
    var $input = $button.parent().find('input[type=text]');
    var oldValue = $input.val();
    if ($button.text() == "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
     // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $input.val(newVal);
    updatePrice();
  });

  $('#fecha').dateTimePicker({
      //limitMin: new Date(2019,11,28), //a partir del 28 diciembre 2019
      format: 'dd/MM/yyyy'
      
  });

});

function updatePrice(){
  var i = 0;
  var total = 0;
  $('.precio').each(function() {
    var price = parseFloat( $('input[name="dishes['+i+'][price]"]').val().replace(',', '.') );
    var num = parseInt( $('input[name="dishes['+i+'][num]"]').val() );
    if(num > 0){
      total = total + ( price * num );
    }
    i = i + 1;
  });

  $('#preciototal').empty().append(total+' €');
  $('#total').val(total);
}


function altura_fondo() {
    var h = $(window).height();
    var w = $(window).width();

    if (window.innerWidth > 800) {
     // $('#slider').height(h - 200);
    } else {
     // $('#slider').height(h - 160);
    }

    var hinsta = $('.instagram-container').width();
    if(w > 600){
      $('#lastposts').css('height', (hinsta/2)+'px');
    }else{
      $('#lastposts').css('height', hinsta+'px');
    }


};

function mover(el, val) {
    el.style.WebkitTransform = val;
    el.style.MozTransform = val;
    el.style.transform = val;
}

function cerrar() {
    //mover(document.getElementById('container'), '');
    mover(document.getElementById('menu-desplegable'), '');
    $('#negroID').fadeOut();
    $('#nav-open-close').removeClass('open');
}

$(window).scroll(function() {

}).resize(function() {
  altura_fondo();
  cerrar();
});


/*------- /VALIDACIO DEL FORMULARI --------*/
function limpiaForm(miForm) {
    // recorremos todos los campos que tiene el formulario
    $(':input', miForm).each(function() {
        var type = this.type;
        var tag = this.tagName.toLowerCase();
        //limpiamos los valores de los campos…
        if (type == 'text' || type == 'password' || tag == 'textarea' || type == 'email')
            this.value = "";
        // excepto de los checkboxes y radios, le quitamos el checked
        // pero su valor no debe ser cambiado
        else if (type == 'checkbox' || type == 'radio')
            this.checked = false;
        // los selects le ponesmos el indice a -
        else if (tag == 'select')
            this.selectedIndex = -1;
    });
}

